import { render, staticRenderFns } from "./ListBody.vue?vue&type=template&id=3ff16e66&scoped=true"
import script from "./ListBody.vue?vue&type=script&lang=js"
export * from "./ListBody.vue?vue&type=script&lang=js"
import style0 from "./ListBody.vue?vue&type=style&index=0&id=3ff16e66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff16e66",
  null
  
)

export default component.exports